import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "94121601-9e6e-4744-a720-3484dc7b15b9",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "bf22e0a5-f3bf-4b6c-a7d7-a0bbb2d81241",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "my_farm_popup",
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "abc0cec8-c740-4359-a2ec-9b7938096a5f",
      type: "Sprite",
      name: "closeButton",
      nameSpace: "",
      className: "",
      x: 249,
      y: -216,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "btn_close",
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "8d13120d-5dce-4dea-8e91-027c11bb2277",
      type: "Text",
      name: "headerText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -222,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "AreaUnlockHeader",
      localize: true,
      maxWidth: 420,
      maxHeight: 78,
      maxFontSize: 55,
      icons: [],
      style: {
        fontSize: 55,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#a9593e",
        strokeThickness: 7,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "02d5b708-2242-40ea-b0ba-e75a1c2e4c6c",
      type: "Text",
      name: "titleText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -123,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "AreaUnlockTitle",
      localize: true,
      maxWidth: 386,
      maxHeight: 50,
      maxFontSize: 35,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "2a4ac74e-d098-40c5-97da-7dc9d45574ab",
      type: "Container",
      name: "",
      nameSpace: "itemsContainer",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "d54a1064-2e5e-4a68-8026-2831e8c8f1d0",
      type: "Sprite",
      name: "buyButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 179,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.900344,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_green",
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "2c5a8a51-9e92-489b-9ee0-ef7b108edb23",
      type: "Container",
      name: "coinBarContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: -315,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "94121601-9e6e-4744-a720-3484dc7b15b9",
      data: ""
    },
    {
      id: "dab019d3-208f-47bf-a5f1-38e28f153fe2",
      type: "Container",
      name: "area_0",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "2a4ac74e-d098-40c5-97da-7dc9d45574ab",
      data: ""
    },
    {
      id: "565402da-75e7-4976-913b-0ade0383e09a",
      type: "Container",
      name: "area_1",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "2a4ac74e-d098-40c5-97da-7dc9d45574ab",
      data: ""
    },
    {
      id: "81ac4aea-6f1b-45a0-b1ef-cbf8c9428c48",
      type: "Container",
      name: "area_2",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "2a4ac74e-d098-40c5-97da-7dc9d45574ab",
      data: ""
    },
    {
      id: "2dcdb47e-9c0d-4f01-879c-08a21aac1137",
      type: "Container",
      name: "area_3",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "2a4ac74e-d098-40c5-97da-7dc9d45574ab",
      data: ""
    },
    {
      id: "7fefa7b2-f96a-432f-b752-d26cf6046e21",
      type: "Container",
      name: "area_4",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "2a4ac74e-d098-40c5-97da-7dc9d45574ab",
      data: ""
    },
    {
      id: "8d38602f-6c10-4226-92e4-d4d81ab62916",
      type: "Sprite",
      name: "coin",
      nameSpace: "",
      className: "",
      x: -70,
      y: 1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_medium_popup",
      parent: "d54a1064-2e5e-4a68-8026-2831e8c8f1d0",
      data: ""
    },
    {
      id: "32ae1b58-cfa7-4b22-b614-bc89fe15203a",
      type: "Text",
      name: "areaPrice",
      nameSpace: "",
      className: "",
      x: -30,
      y: -3,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "25000",
      localize: false,
      maxWidth: 131,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#277617",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "d54a1064-2e5e-4a68-8026-2831e8c8f1d0",
      data: ""
    },
    {
      id: "76957426-d59f-487f-b626-2c68216a55e7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "task_small",
      parent: "dab019d3-208f-47bf-a5f1-38e28f153fe2",
      data: ""
    },
    {
      id: "97e79407-09f5-477e-99fa-99f2d6381c1b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -82,
      y: -35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "task_crop",
      parent: "565402da-75e7-4976-913b-0ade0383e09a",
      data: ""
    },
    {
      id: "23a175cd-9c5b-4e76-aeb8-2b4eabd28322",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 64,
      y: -35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "task_small",
      parent: "565402da-75e7-4976-913b-0ade0383e09a",
      data: ""
    },
    {
      id: "5eca545c-1569-4500-9d0d-c7b6bc52e070",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -129,
      y: -35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "task_crop",
      parent: "81ac4aea-6f1b-45a0-b1ef-cbf8c9428c48",
      data: ""
    },
    {
      id: "3502388c-def0-4c14-a3b8-bb04a2f6f98e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "task_small",
      parent: "81ac4aea-6f1b-45a0-b1ef-cbf8c9428c48",
      data: ""
    },
    {
      id: "eb44ce9e-f476-4172-85b4-9890d37737bf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 133,
      y: -35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "task_big",
      parent: "81ac4aea-6f1b-45a0-b1ef-cbf8c9428c48",
      data: ""
    },
    {
      id: "407f1271-6999-49db-9233-157281388051",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "task_crop",
      parent: "2dcdb47e-9c0d-4f01-879c-08a21aac1137",
      data: ""
    },
    {
      id: "ef917cf3-a00f-4187-93f2-94cb2c619b03",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 64,
      y: -35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "task_big",
      parent: "7fefa7b2-f96a-432f-b752-d26cf6046e21",
      data: ""
    },
    {
      id: "0e1eea03-dd31-4a82-afff-7f0faddbddcd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -82,
      y: -35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "task_small",
      parent: "7fefa7b2-f96a-432f-b752-d26cf6046e21",
      data: ""
    },
    {
      id: "0ac7545f-23c6-4225-bb46-c5db19e93767",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x10",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "76957426-d59f-487f-b626-2c68216a55e7",
      data: ""
    },
    {
      id: "a3fcb8b9-9185-481e-b4a6-889615b38356",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x4",
      localize: false,
      maxWidth: 9,
      maxHeight: 0,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "97e79407-09f5-477e-99fa-99f2d6381c1b",
      data: ""
    },
    {
      id: "44792681-9ed1-4bfd-85c7-12e963a1255e",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 9,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x2",
      localize: false,
      maxWidth: 10,
      maxHeight: 0,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "23a175cd-9c5b-4e76-aeb8-2b4eabd28322",
      data: ""
    },
    {
      id: "bfa27092-117d-4995-bb3a-bdb2c61d8cb6",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x6",
      localize: false,
      maxWidth: 9,
      maxHeight: 0,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "5eca545c-1569-4500-9d0d-c7b6bc52e070",
      data: ""
    },
    {
      id: "108cc095-eb04-4b5c-b3e3-05b2aa9e24c6",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 9,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x1",
      localize: false,
      maxWidth: 9,
      maxHeight: 0,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "3502388c-def0-4c14-a3b8-bb04a2f6f98e",
      data: ""
    },
    {
      id: "29004371-4b44-4a46-9d6a-c8710b053125",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x1",
      localize: false,
      maxWidth: 9,
      maxHeight: 0,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "eb44ce9e-f476-4172-85b4-9890d37737bf",
      data: ""
    },
    {
      id: "29cd7b78-9a9a-4fe5-835b-db3d4f994c13",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x8",
      localize: false,
      maxWidth: 9,
      maxHeight: 0,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "407f1271-6999-49db-9233-157281388051",
      data: ""
    },
    {
      id: "79dfe67d-9fb4-41d3-9405-576507eff5e8",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x1",
      localize: false,
      maxWidth: 9,
      maxHeight: 0,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "ef917cf3-a00f-4187-93f2-94cb2c619b03",
      data: ""
    },
    {
      id: "0ebe9677-8964-4388-b3e3-ecab46e8cffe",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 9,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x2",
      localize: false,
      maxWidth: 10,
      maxHeight: 0,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "#933019",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "0e1eea03-dd31-4a82-afff-7f0faddbddcd",
      data: ""
    }
  ]
} as const;

export class AreaUnlockPopupLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  closeButton: GameObject<PIXI.Sprite>;
  headerText: GameObject<PIXI.Text>;
  titleText: GameObject<PIXI.Text>;
  buyButton: GameObject<PIXI.Sprite>;
  coin: GameObject<PIXI.Sprite>;
  areaPrice: GameObject<PIXI.Text>;
  coinBarContainer: GameObject<PIXI.Container>;
  itemsContainer: {
    area_0: GameObject<PIXI.Container>
    area_1: GameObject<PIXI.Container>
    area_2: GameObject<PIXI.Container>
    area_3: GameObject<PIXI.Container>
    area_4: GameObject<PIXI.Container>
    children: (GameObject<PIXI.Container>)[]
  };

  constructor() {
    populate(this, raw);
  }
}
